import React, {  useState,useEffect } from 'react'
import { connect } from 'react-redux';
import { Card, Tag, Tooltip, Button,Modal, Row, Col, Empty,Input } from 'antd';
import { DeleteOutlined,ExclamationCircleOutlined,SearchOutlined,EditOutlined } from '@ant-design/icons';
import {getAccountAppLicensesPurchases,deleteAccountAppLicensePurchase,setAddEdit} from "redux/actions/accountAppLicense"
import { debounce } from 'lodash';
import { motion } from "framer-motion"
import CustomTable from 'components/util-components/CustomTable';
import { useTranslation } from "react-i18next";
import AddAccountAppLicensePurchasePage  from '../add-account-app-licenses-purchase';

const AccountAppLicensesPurchasePage=(props)=> {


   const {  accountAppLicensePurchaseData,getAccountAppLicensesPurchases,deleteAccountAppLicensePurchase, setAddEdit  } = props;
   const { accountAppLicensesPurchases,addEditValue,loading,showMessage } = accountAppLicensePurchaseData;
   const [query, setQuery] = useState(undefined);
   const [loader,setLoader]=useState(true);

   //const [addEdit, setAddEdit] = useState(false);
   const [ accountAppLicensePurchase,setAccountAppLicensePurchase] = useState({});
   const { t } = useTranslation();
   const [pagination] =useState({current:1,pageSize:10});
   const { param } = props;
   const { appInstanceId } = param;

   useEffect(() => {
	setLoader(true);
    getAccountAppLicensesPurchases({appInstanceId,pagination});
	setAddEdit(false);
  },[]);

  useEffect(() => {
	if(accountAppLicensesPurchases?.totalElements>=0)
	setLoader(false);
  },[accountAppLicensesPurchases]);

  const searchOnClick =debounce((e) => {
	const query = e.target.value;
	setQuery(query);
	setLoader(true);
	getAccountAppLicensesPurchases({appInstanceId,query});
},500);


	const  onBoardDelete = accountAppLicensePurchase=> {

		Modal.confirm({
			title: `Do you want to delete ${accountAppLicensePurchase.id} Permission?`,
			icon: <ExclamationCircleOutlined />,
			okText: 'Yes',
			cancelText: 'Cancel',
			onOk() {
				deleteAccountAppLicensePurchase(accountAppLicensePurchase);
			},
		});
	}
	const onSortData = (pagination, filters, sorter) => {
		console.log(pagination);
	}
	const handleTableChange = (pagination, filters, sorter) => {
		console.log(pagination);
		console.log(filters);
		console.log(sorter);
		setLoader(true);
		getAccountAppLicensesPurchases({appInstanceId,query:"",sorter,pagination});
	  };

	const  onAdd = ()=> {
       setAddEdit(true);
       setAccountAppLicensePurchase();
	}
    const  onEdit = (accountAppLicense)=> {
        console.log(accountAppLicense);
        setAccountAppLicensePurchase(accountAppLicense);
        setAddEdit(true);
     }
    const cancel=()=>{
        setAddEdit(false);
    }
    
		const tableColumns = [
			{
				title: t("impaqx.adminApp.qty"),
				dataIndex: 'qty',
			
				sorter: onSortData
			},
			{
				title: t("impaqx.adminApp.price"),
				dataIndex: 'price',
				sorter: onSortData
			},
			{
				title: t("impaqx.adminApp.currency"),
				dataIndex: 'currency',
				sorter: onSortData
			},
			{
				title: t("impaqx.adminApp.pricePerQty"),
				dataIndex: 'pricePerQty',
				sorter: onSortData
			},
			{
				title: t("impaqx.adminApp.licenseEffectiveDate"),
				dataIndex: 'licenseEffectiveDate',
				sorter: onSortData
			},
			{
				title: t("impaqx.adminApp.licenseExpiryDate"),
				dataIndex: 'licenseExpiryDate',
				sorter: onSortData
			},
			{
				title: t("impaqx.adminApp.purchaseDate"),
				dataIndex: 'purchaseDate',
				sorter: onSortData
			},
            {
				title: t("impaqx.adminApp.renewalDate"),
				dataIndex: 'renewalDate',
				sorter: onSortData
			},
            {
				title: t("impaqx.adminApp.priceOverrideNote"),
				dataIndex: 'priceOverrideNote',
				sorter: onSortData
			},
			{
				title: t("impaqx.adminApp.status"),
				dataIndex: 'status',
				render: status => (
					<Tag className ="text-capitalize" color={status === 'ACTIVE'? 'cyan' : 'red'}>{status}</Tag>
				),
				sorter:onSortData
			},
			{
				title: '',
				dataIndex: 'actions',
				render: (_, elm) => (
					<div className="text-right d-flex justify-content-end">
						{/* <Tooltip title="Select">
                        <Button className="mr-2"  disabled={elm.disableSelection} onClick={()=>{onSelectAccount(elm)}} size="small">Select</Button>
						</Tooltip> */}
						 <Tooltip title={t("impaqx.adminApp.edit")}>
                        <Button className="mr-2"  disabled={elm.disableSelection} icon={<EditOutlined />} onClick={()=>{onEdit(elm)}} size="small"/>
						</Tooltip>
						{/* <Tooltip title="View">
							<Button type="primary" disabled={elm.disableSelection} className="mr-2" icon={<EyeOutlined />} onClick={() => {showUserProfile(elm)}} size="small"/>
						</Tooltip> */}
						<Tooltip title={t("impaqx.adminApp.delete")}>
							<Button danger icon={<DeleteOutlined />} disabled={elm.disableSelection} onClick={()=>{onBoardDelete(elm)}} size="small"/>
						</Tooltip>
					</div>
				)
			}
		];

		
		return (
			<> 
			<motion.div 
				initial={{ opacity: 0, marginBottom: 0 }} 
				animate={{ 
					opacity: showMessage ? 1 : 0,
					marginBottom: showMessage ? 20 : 0 
				}}> 
				</motion.div>
               {addEditValue? <AddAccountAppLicensePurchasePage param={param} accountAppLicensePurchase={accountAppLicensePurchase} cancel={cancel} loading={loading}/>:null}
			{!loader && accountAppLicensesPurchases?.totalElements>0 && !addEditValue?<>
			<div className="d-flex justify-content-between align-items-center mb-3">
				<Input
					placeholder="Search"
					onChange={searchOnClick}
					prefix={<SearchOutlined className="font-size-lg mr-2"/>}
					style={{ maxWidth: 280 }}
				/>
				<Button type="primary" className="ant-btn ant-btn-primary ant-btn-sm" onClick={()=>{onAdd()}} size="small">
					<span>{t("impaqx.adminApp.add")}</span>
				</Button>
			</div></>:null}
			 {!addEditValue && !loader && !(accountAppLicensesPurchases?.totalElements>0) && query === undefined? 
			<Row justify="center" gutter={24}>
					<Col xs={24} sm={24} md={12} lg={12} className="gutter-row">
					<Card style={{textAlign: "center"}}>
				<Empty
			image="https://gw.alipayobjects.com/mdn/miniapp_social/afts/img/A*pevERLJC9v0AAAAAAAAAAABjAQAAAQ/original"
			imageStyle={{
			height: 60,
			}}
			description={
			<span>
				{t("impaqx.adminApp.noDataAvailableCreateNow")}
						</span>
				}
			>
			<div className="text-right d-flex justify-content-center">
				<Button type="primary" onClick={()=>{onAdd()}} size="small" >{t("impaqx.adminApp.createNow")}</Button></div>
			</Empty></Card></Col></Row>:!addEditValue?<Card bodyStyle={{'padding': '0px'}}>
				<div className="table-responsive">
					<CustomTable columns={tableColumns} dataSource={accountAppLicensesPurchases} className="customTable" rowKey='id' pagination={{total :accountAppLicensesPurchases?.totalElements}} 
        onChange={handleTableChange} loading={loader}/>
				</div>
			</Card>:null}
			</>
		)
	
}

const mapStateToProps = state => ({
	accountAppLicensePurchaseData: state.accountAppLicense,
});
export default connect(
  mapStateToProps,
  {  getAccountAppLicensesPurchases,deleteAccountAppLicensePurchase,setAddEdit}
)(AccountAppLicensesPurchasePage);
